import { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { footerLinks } from '../../data/mock';

export const FloatingWhatsApp = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 800);
    return () => clearTimeout(timer);
  }, []);

  const whatsappUrl = `https://wa.me/${footerLinks.contact.whatsapp}?text=Hi! I'm interested in your digital services.`;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.7, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="fixed bottom-4 right-4 sm:bottom-5 sm:right-5 md:bottom-6 md:right-6 z-[9999]"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <AnimatePresence>
            {showTooltip && (
              <motion.div
                initial={{ opacity: 0, x: 10, scale: 0.95 }}
                animate={{ opacity: 1, x: 0, scale: 1 }}
                exit={{ opacity: 0, x: 10, scale: 0.95 }}
                className="hidden md:block absolute right-16 bottom-2 bg-[#111d33] text-white text-sm px-4 py-2 rounded-lg whitespace-nowrap border border-slate-700/50 shadow-xl pointer-events-none"
              >
                Chat with us on WhatsApp
                <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 rotate-45 bg-[#111d33] border-r border-t border-slate-700/50" />
              </motion.div>
            )}
          </AnimatePresence>

          <div className="relative w-14 h-14 sm:w-[58px] sm:h-[58px]">
            <span
              className="pointer-events-none absolute inset-0 rounded-full bg-[#25D366]/30 animate-ping"
              style={{ animationDuration: '2s' }}
            />

            <span className="pointer-events-none absolute -inset-2 rounded-full bg-[#25D366]/10 blur-lg" />

            <motion.a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat with us on WhatsApp"
              whileTap={{ scale: 0.94 }}
              className="relative z-10 flex items-center justify-center w-14 h-14 sm:w-[58px] sm:h-[58px] rounded-full bg-[#25D366] shadow-lg shadow-[#25D366]/30 touch-manipulation"
            >
              <MessageCircle className="w-6 h-6 text-white" />
            </motion.a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};